import { IoSearch } from "react-icons/io5";
import styles from "../styles/ui/SearchBox.module.css";

function SearchBox({
  value,
  onChange,
  wrapperStyle = {},
  wrapperClassName = "",
  inputClassName = "",
  inputStyle = {},
  placeholder = "Search...",
}) {
  return (
    <div
      className={`${styles.searchBox} ${wrapperClassName}`}
      style={wrapperStyle}
    >
      <IoSearch className={styles.searchIcon} size={18} />
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${styles.searchInput} ${inputClassName}`}
        style={inputStyle}
      />
    </div>
  );
}

export default SearchBox;
